import StructuringPanel from "../components/StructuringPanel";

/**
 * StructuringPage — eigenständige Steuer-Strukturierungs-Seite.
 * 16 weltweite Strukturen werden mit Profilangaben verglichen, am Ende
 * Lawyer-Match. STRENG: keine Empfehlung, nur Vergleich.
 */
export default function StructuringPage() {
  return (
    <div className="space-y-6">
      <header>
        <div className="flex items-baseline justify-between flex-wrap gap-2">
          <h1 className="text-3xl font-bold tracking-tight">Steuer-Strukturierung</h1>
          <span className="text-xs text-slate-500">
            weltweiter Vergleich · KEINE Empfehlung · Lawyer-Match
          </span>
        </div>
        <p className="mt-2 text-slate-400 max-w-2xl">
          Beschreibe deine Lebenslage (Wohnsitz, Vermögen, Familie, Ziele). Der internationale
          Steuer-Schwarm vergleicht weltweit verfügbare Strukturen — Stiftungen, Trusts,
          Holdings, PPLI, Family Office, Crypto-Setups, Wohnsitz-Optimierungen — und
          liefert eine Vergleichstabelle mit Eignung, § 42 AO Risiko und Kosten.
        </p>
      </header>

      <section className="rounded-2xl border border-court-700/40 bg-gradient-to-br from-court-900/20 via-slate-900/40 to-slate-900/40 p-6">
        <StructuringPanel />
      </section>

      <div className="rounded-xl border border-amber-800/40 bg-amber-950/20 p-4 text-xs text-amber-200/80 leading-relaxed">
        <strong className="text-amber-200">Wichtig:</strong> Shadow Court erteilt KEINE
        Steuer-/Rechtsberatung im Sinne § 1 StBerG / § 2 RDG. Der Vergleich ist informativ.
        Vor jeder Strukturentscheidung zwingend einen qualifizierten Steuerberater UND
        einen Anwalt im Zielland einbinden — der Lawyer-Match-Service vermittelt passende
        Kontakte aus unserem 12er-Berater-Pool.
      </div>
    </div>
  );
}
